import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get, sortBy } from 'lodash'

import { apiAdventurousJourney } from 'helpers/decorators/api/dashboard'
import { Overview } from 'components/misc'
import { MaterialControlBar, DashboardGrid as Grid } from 'components/layout'
import { AJAttachedFiles } from 'containers/sections/aj-events'
import {
  ACTIVITY_SECTIONS,
  ACTIVITY_STATES,
  AJ_EVENT_CATEGORIES
} from 'constants/enums'
import MODALS from 'constants/layout/modals'
import { connect } from 'react-redux'
import { apiConfiguration } from '../../../helpers/decorators/api'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'

const completedStates = [
  ACTIVITY_STATES.complete.id,
  ACTIVITY_STATES.ceremony.id,
  ACTIVITY_STATES.office_signoff.id
]

@apiAdventurousJourney()
@apiConfiguration()
@connect(({ api }) => ({
  dashboard: api.dashboard
}))
class AJOverview extends Component {
  static propTypes = {
    event: PropTypes.object,
    aJValues: PropTypes.object.isRequired,
    isPrepAndTrain: PropTypes.bool,
    onOpen: PropTypes.func,
    dashboard: PropTypes.object
  }

  openEditModal = () =>
    this.props.onOpen(
      `${MODALS.OVERVIEW_PE}_${get(this.props.event, 'id')}`,
      null,
      { missingData: true }
    )

  openSetupModal = () =>
    this.props.onOpen(MODALS.ADD_PE_JOURNEY, null, {
      journey: {
        ...this.props.event,
        id: undefined
      },
      resetOnMount: true
    })

  renderPrepAndTrain = () => {
    const unsortedEntries = get(
      this.props.aJValues,
      'data.ajPreparationAndTrainingList',
      []
    ).filter(item => item.isCompleted)
    const logEntries = sortBy(unsortedEntries, obj => obj.date)
    const isLoading = get(this.props.aJValues, 'loading')

    return (
      <Grid.RightInner white>
        <div className="row">
          <div className="col-xs-12">
            <Overview
              activityOverview={{ loading: isLoading }}
              activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
              content={[
                {
                  id: '1',
                  content: get(
                    this.props.aJValues,
                    'data.ajPreparationAndTrainingStateType.translationText'
                  ),
                  intlKey: 'label.status',
                  label: 'Status',
                  ico: 'info'
                },
                {
                  id: '2',
                  content: get(logEntries[0], 'name'),
                  intlKey: 'label.first_log_entry',
                  label: 'First Log Entry',
                  ico: 'edit'
                },
                {
                  id: '3',
                  content: get(logEntries[0], 'date'),
                  intlKey: 'label.first_log_entry_date',
                  label: 'First Log Entry Date',
                  ico: 'date',
                  date: true
                },
                {
                  id: '4',
                  content: get(logEntries[logEntries.length - 1], 'name'),
                  intlKey: 'label.last_log_entry',
                  label: 'Last Log Entry',
                  ico: 'edit'
                },
                {
                  id: '5',
                  content: get(logEntries[logEntries.length - 1], 'date'),
                  intlKey: 'label.last_log_entry_date',
                  label: 'Last Log Entry Date',
                  ico: 'date',
                  date: true
                }
              ]}
            />
          </div>
        </div>
      </Grid.RightInner>
    )
  }

  getAssessorName = (event, isAssessorManagementEnabled) => {

    if(isAssessorManagementEnabled && get(event, 'ajEvent.assessor')){
        return `${get(event, 'ajEvent.assessor.person.name')}`
    } else {
      return get(event, 'ajEvent.assessorName') && `${event.ajEvent.assessorName}`
    }

  }

  getAssessorEmail = (event, isAssessorManagementEnabled) => {

    if(isAssessorManagementEnabled && get(event, 'ajEvent.assessor')){
      return `${get(event, 'ajEvent.assessor.person.email')}`
    } else {
      return get(event, 'ajEvent.assessorEmail')
    }

  }

  render() {
    const { aJValues, event, isPrepAndTrain } = this.props

    const isLoading = get(aJValues, 'loading')
    const isCompleted = completedStates.includes(get(event, 'state.value'))
    const hasPJInSetup = get(aJValues, 'data.adventurousJourneys', []).some(
      journey =>
        get(journey, 'ajEventCategoryType') ===
          AJ_EVENT_CATEGORIES.practice.id &&
        get(journey, 'state.value') === ACTIVITY_STATES.setup.id
    )
    const canAdd =
      get(event, 'ajEventCategoryType') === AJ_EVENT_CATEGORIES.practice.id &&
      !isCompleted &&
      !hasPJInSetup
    const canEdit = get(event, 'state.value') === ACTIVITY_STATES.in_progress.id

    if (isPrepAndTrain) {
      return this.renderPrepAndTrain()
    }

    const isAssessorManagementEnabled= isAssessorManagementEnabledForActivity(get(event, 'ajEvent'))

    const assessorRegState = get(event, 'ajEvent.assessorRegistrationState')

    let assessorDetailContent = [
      {
        id: '10',
        content: this.getAssessorName(event, isAssessorManagementEnabled),
        intlKey: 'label.name',
        label: 'Name',
        ico: 'face'
      }
    ]

    if(!isAssessorManagementEnabled){
      assessorDetailContent.push({
        id: '11',
        content: this.getAssessorEmail(event, isAssessorManagementEnabled),
        intlKey: 'label.email',
        label: 'Email',
        ico: 'email'
      })
    }


    if (isAssessorManagementEnabled) {
      assessorDetailContent.push({
        id: '12',
        content: assessorRegState,
        intlKey: 'label.assessor_state',
        label: 'Assessor state',
        ico: 'timer'
      })
    }
    const transportationModes = get(event, 'ajEvent.transportationModes') || []

    const transportationModeList = transportationModes && transportationModes.map(item => {
      return get(item, 'transportationMode.modeOfTransportType.translationText')
    })

    return (
      <Grid.RightInner white>
        {(canAdd || canEdit) &&
          <MaterialControlBar
            add={
              canAdd && {
                onClick: this.openSetupModal,
                label: 'Add additional journey',
                intlKey: 'button.add_additional_journey'
              }
            }
            edit={
              canEdit && {
                onClick: this.openEditModal,
                label: 'Edit',
                intlKey: 'button.edit'
              }
            }
          />}
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Overview
              activityOverview={{ loading: isLoading }}
              activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
              title="Journey Details"
              titleKey="moduleTitle.journey_details"
              content={[
                {
                  id: '1',
                  content: get(event, 'ajEvent.title'),
                  intlKey: 'label.name',
                  label: 'Name',
                  ico: 'subject'
                },
                {
                  id: '2',
                  content: get(event, 'aim') || get(event, 'ajEvent.aim'),
                  intlKey: 'label.team_goal',
                  label: 'Team Goal',
                  ico: 'flag'
                },
                {
                  id: '3',
                  content: get(event, 'ajEvent.startDate'),
                  intlKey: 'label.start_date',
                  label: 'Start Date',
                  ico: 'date',
                  date: true
                },
                {
                  id: '4',
                  content: get(event, 'ajEvent.endDate'),
                  intlKey: 'label.end_date',
                  label: 'End Date',
                  ico: 'date',
                  date: true
                },
                {
                  id: '5',
                  content: get(
                    event,
                    'ajEvent.activityCategory.translatedName'
                  ),
                  intlKey: 'label.journey_activity',
                  label: 'Journey Activity',
                  ico: 'filter-hdr'
                },
                {
                  id: '6',
                  content: transportationModeList.length > 1 ? transportationModeList.join(',') : transportationModeList,
                  intlKey: 'label.mode_of_transport',
                  label: 'Mode of Transport',
                  ico: 'bike'
                },
                {
                  id: '7',
                  content: get(event, 'ajEvent.country.name'),
                  intlKey: 'label.location',
                  label: 'Location',
                  ico: 'map'
                },
                {
                  id: '8',
                  content: get(event, 'ajEvent.note'),
                  intlKey: 'label.note',
                  label: 'Note',
                  ico: 'subject'
                }
              ]}
            />
          </div>
          <div className="col-xs-12 col-sm-6">
            <Overview
              activityOverview={{ loading: isLoading }}
              activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
              title="Assessor Detail"
              titleKey="moduleTitle.assessor_details"
              content={assessorDetailContent}
            />

            <Overview
              activityOverview={{ loading: isLoading }}
              activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
              title="Supervisor Detail"
              titleKey="formTitle.supervisors_details"
              content={[
                {
                  id: '21',
                  content: get(event, 'ajEvent.supervisorName') &&
                    `${get(event, 'ajEvent.supervisorTitle')} ${event.ajEvent.supervisorName}`,
                  intlKey: 'label.name',
                  label: 'Name',
                  ico: 'face'
                },
                {
                  id: '22',
                  content: get(event, 'ajEvent.supervisorEmail'),
                  intlKey: 'label.email',
                  label: 'Email',
                  ico: 'email'
                }
              ]}
            />
          </div>
        </div>
        {get(event, 'ajEvent.id') &&
          <AJAttachedFiles ajId={event.ajEvent.id} />}
      </Grid.RightInner>
    )
  }
}

export default AJOverview
